import React from 'react';
import { Button } from '@scuf/common';

import './TextTabbedSwitchTheme.scss';

export interface ITextTabbedSwitchProps {
  onTabChange: (id: string) => void;
  activeTab: string;
  tabList: { id: string; label: string }[];
  groupClassName?: string;
  tabClassName?: string;
  children?: React.ReactNode;
}

export const TextTabbedSwitch = (props: ITextTabbedSwitchProps) => {
  const {
    activeTab,
    onTabChange,
    tabList,
    groupClassName,
    tabClassName,
    children
  } = props;
  return (
    <div className="EO-Tab-Switches">
      <Button.Group
        className={`tabbed-switch-group-text ${groupClassName || ''}`}
      >
        {tabList.map((val: { id: string; label: string }, _idx) => (
          <Button
            key={`${val.id}-tabbed-switch-${_idx}`}
            className={`tabbed-switch-text ${tabClassName || ''} ${
              activeTab == val.id ? 'active' : 'inactive'
            }`}
            type={activeTab == val.id ? 'inline' : 'inline-secondary'}
            content={val.label}
            onClick={() => {
              onTabChange(val.id);
            }}
          />
        ))}
      </Button.Group>
      {children}
    </div>
  );
};
